import { SearchSelect } from './SearchSelect/SearchSelect';
import { InlineGroup } from './InlineGroup/InlineGroup';
import { MultiSelect } from './MultiSelect/MultiSelect';
import { Checkbox } from './Checkbox/Checkbox';
import { Select } from './Select/Select';
import { Field } from './Field/Field';
import { Group } from './Group/Group';
import { Label } from './Label/Label';
import { File } from './File/File';

export type { Props as SearchSelectProps } from './SearchSelect/SearchSelect';
export type { Props as MultiSelectProps } from './MultiSelect/MultiSelect';
export type { Props as SelectProps } from './Select/Select';
export type { Props as FieldProps } from './Field/Field';

export const Input = {
  SearchSelect,
  MultiSelect,
  InlineGroup,
  Checkbox,
  Select,
  Label,
  Field,
  File,
  Group,
};
